import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
 Stack, TextArea
} from '@carbon/react';
import { Root } from './Scheduled.styles'
import { Filter } from '@carbon/icons-react'
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card'
import Typography from "../../../components/Basics/Typography";
import { DataTable as TableIcon } from '@carbon/icons-react'
import { useInput } from "../../../components/Inputs/Inputs.hooks";
import { checkErrorRequired } from "../../../modules/errors/validations";
import { onSentScheduledThunk } from "./Scheduled.actions";

const ScheduledModalContainer = ({ button, open, setOpen, truckPatent }) => {
  const dispatch = useDispatch()
  const { error: commentError, value: commentValue, onChange: handleCommentChange } = useInput({
    errorCallbacks: [checkErrorRequired()]
  })

  const { sendingComment, commentErrorPayload } = useSelector(state => state.scheduled)
  
  const getLoadingStatus = () => {
    if (commentErrorPayload) {
      return 'error'
    }
    if (sendingComment) {
      return 'active'
    }
    return 'inactive'
  }
  
  const handleSubmitExcelData = () => {
    const params = {
      truck: truckPatent,
      incommingComment: commentValue
    }
    dispatch(onSentScheduledThunk({
      truck: truckPatent,
      incommingComment: commentValue
     }));
  };

  return (
    <Root 
      danger
      modalLabel="Comentario"
      modalHeading={truckPatent}
      launcherButtonRef={button}
      primaryButtonText="Completar"
      onRequestSubmit={handleSubmitExcelData}
      loadingStatus={getLoadingStatus()}
      open={open}
      onRequestClose={() => setOpen(false)}
    >
      <Stack gap={3}>
        <CardRow>
          <CardComponent width="100%">
            <Card justifyContent='flex-start'>
              <TableIcon size={18} />
              <Typography className='cds--type-heading-compact-01'>
                Aquí puede modificar el comentario que aparece en la tabla de equipos.
            </Typography>
            </Card>
          </CardComponent>
        </CardRow>
        <CardRow>
          <CardComponent width="100%">
            <Card justifyContent='flex-start'>
                <TextArea
                    labelText='COMENTARIO'
                    enableCounter
                    maxCount={1000}
                    placeholder='...'
                    onChange={handleCommentChange}
                    value={commentValue}
                    helperText="Este Comentario quedara guardado junto al equipo."
                />
            </Card>
          </CardComponent>
        </CardRow>
        {commentErrorPayload ? 'Error al tratar de enviar, favor pongase en contacto' : ''}
        {sendingComment ? 'Enviando' : ''}
      </Stack>
    </Root>
  )
}

export default ScheduledModalContainer
